import { Navigate, Route, Routes } from 'react-router-dom';

import { LayoutContent } from '@/common/components/Layout';
import { useResource } from '@/common/resources';
import { DocTitle } from '@/common/utils/DocTitleUtils';

import { ConnectedAppsView } from './components/connected-apps';
import { PATHS } from './constants';

export const SettingsView = () => {
  const { docTitle } = useResource((resource) => resource.APP_SETTINGS);

  return (
    <>
      <DocTitle>{docTitle}</DocTitle>
      <LayoutContent>
        <Routes>
          <Route path={PATHS.connectedApps} element={<ConnectedAppsView />} />
          <Route index element={<Navigate to={PATHS.connectedApps} replace />} />
        </Routes>
      </LayoutContent>
    </>
  );
};
